var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { CANCEL_REFRESH_REPORT_STATS, GET_REPORT_PROJECTS_SUCCESS, GET_REPORT_STATS_SUCCESS, REFRESH_REPORT_STATS_REQUEST, SET_REPORT_FILTERS } from './reports.actions';
import { createSelector } from 'reselect';
import { sumImpressions } from '../../shared/utils/sumImpressions';
export var initialState = { projects: [] };
export function reportsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_REPORT_PROJECTS_SUCCESS:
            var projects = action.payload.map(function (_a) {
                var id = _a.id, name = _a.name;
                return ({ id: id, name: name });
            });
            return __assign({}, state, { projects: projects });
        case SET_REPORT_FILTERS:
            return __assign({}, state, { filters: action.payload });
        case GET_REPORT_STATS_SUCCESS:
            var stats = {
                impressions: sumImpressions(action.payload.popup) || 0,
                leads: action.payload.popup.popupSubmitted || 0,
                contacted: action.payload.record.callsCount || 0,
                successes: action.payload.record.successContactsCount || 0,
                timesToFirstContact: action.payload.record.timesToFirstContact || []
            };
            return __assign({}, state, { stats: stats });
        case REFRESH_REPORT_STATS_REQUEST:
            return __assign({}, state, { filters: __assign({}, state.filters, { liveModeEnabled: true }) });
        case CANCEL_REFRESH_REPORT_STATS:
            return __assign({}, state, { filters: __assign({}, state.filters, { liveModeEnabled: false }) });
        default: {
            return state;
        }
    }
}
var getProjects = function (reportState) { return reportState.projects; };
var ɵ0 = getProjects;
var getFilters = function (reportState) { return reportState.filters; };
var ɵ1 = getFilters;
var getStats = function (reportState) { return reportState.stats; };
var ɵ2 = getStats;
export var getMainReportsSelector = function (state) { return state.leadGeneration.reports; };
export var getProjectsReportSelector = createSelector(getMainReportsSelector, getProjects);
export var getReportStatsSelector = createSelector(getMainReportsSelector, getStats);
export var getReportFiltersSelector = createSelector(getMainReportsSelector, getFilters);
export { ɵ0, ɵ1, ɵ2 };
